import type { DeepString } from "@/lib/i18n";

/**
 * WCall - polskie tłumaczenia.
 *
 * Fallback gdy backend `content.lang.*` nie dostarczy stringa + komunikaty
 * walidacyjne (zod) + statusy systemowe (rate limit, anti-spam delay, sieć).
 */
export const pl = {
  /** Aria-label widgeta + alt avatara + przycisk zamknięcia. */
  widgetAriaLabel: "Zostaw numer, oddzwonimy",
  consultantAlt: "Konsultant",
  closeLabel: "Zamknij",

  /** Tryb CRM bez aktywnego modułu. */
  crmModeWithoutModule: {
    body1: "Okno jest skonfigurowane w trybie wysyłki do CRM, ale moduł",
    moduleName: "m_crm_sales_support",
    body2:
      'nie jest aktywny w tej domenie. Włącz moduł w panelu administracyjnym lub zmień tryb wysyłki na "email" w konfiguracji okna.',
  },
  unknownSendMode: (mode: string) =>
    `Nieznany tryb wysyłki w konfiguracji okna: ${mode}.`,

  cta: {
    leaveNumber: "Zostaw numer",
  },

  now: {
    title: "Skontaktuj się z nami",
    intro:
      "Podaj numer telefonu - nasz konsultant oddzwoni najszybciej jak to możliwe.",
    btnNow: "Oddzwoń teraz",
    btnLater: "Wybierz porę",
  },

  later: {
    title: "Wybierz dogodną porę",
    intro: "Wskaż dzień i godzinę - oddzwonimy w wybranym terminie.",
    btnSubmit: "Zamów rozmowę",
    btnBack: "Wróć",
  },

  labels: {
    telephone: "Telefon",
    day: "Dzień",
    hour: "Godzina",
  },

  placeholders: {
    selectDay: "Wybierz dzień",
    selectHour: "Wybierz godzinę",
  },

  sending: "Wysyłanie...",

  validation: {
    requiredPhone: "Pole telefonu jest wymagane.",
    invalidPhone: "Niepoprawny numer telefonu.",
    requiredDay: "Wybierz dzień.",
    invalidDay: "Nieprawidłowy dzień.",
    requiredHour: "Wybierz godzinę.",
    invalidHour: "Nieprawidłowa godzina.",
  },

  status: {
    waitBeforeSubmit: (seconds: number) =>
      `Poczekaj jeszcze ${seconds} s przed wysłaniem.`,
    rateLimit: "Zbyt wiele prób z tego adresu IP. Spróbuj za chwilę.",
    sendFailed: "Nie udało się zapisać zgłoszenia.",
    sendSuccess: "Dziękujemy - oddzwonimy najszybciej jak to możliwe.",
    networkError: (message: string) => `Błąd sieci: ${message}`,
    networkErrorGeneric: "Błąd sieci podczas wysyłki.",
  },
} as const;

export type WCallTranslations = DeepString<typeof pl>;
